import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { useRemoteConfig } from '@/composables/useRemoteConfig';

export default async function maintenanceGuard({
  to,
  next,
}: {
  to: RouteLocationNormalized;
  next: NavigationGuardNext;
}) {
  const { maintenanceMode } = await useRemoteConfig();

  if (maintenanceMode.value && to.name !== 'Maintenance') {
    return next({ name: 'Maintenance' });
  }

  next();
}
